import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import CompanyPage from './Company';
import ReviewsPage from './Reviews';
import CertificatesPage from './Certificates';
import PartnersPage from './Partners';

const AboutPage = () => {
  const { section } = useParams<{ section: string }>();

  switch (section) {
    case 'company':
      return <CompanyPage />;
    case 'reviews':
      return <ReviewsPage />;
    case 'certificates':
      return <CertificatesPage />;
    case 'partners':
      return <PartnersPage />;
    default:
      return <Navigate to="/about/company" replace />;
  }
};

export default AboutPage; 